import { render, staticRenderFns } from "./Mark-FixNoInList.vue?vue&type=template&id=384567d4&scoped=true&"
import script from "./Mark-FixNoInList.vue?vue&type=script&lang=js&"
export * from "./Mark-FixNoInList.vue?vue&type=script&lang=js&"
import style0 from "./Mark-FixNoInList.vue?vue&type=style&index=0&id=384567d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384567d4",
  null
  
)

export default component.exports